module.exports = __webpack_public_path__ + "static/media/RXhomePractice.1fcd1516.jpg";